"use strict";
import { importPageLifecycle } from "./asyncModules/importPageLifecycle.js";
function addEventListener(event, func) {
  if (ENAFORE_IS_BROWSER && !ENAFORE_IS_SERVICE_WORKER) {
    importPageLifecycle().then((lifecycle2) => {
      lifecycle2.addEventListener(event, func);
    });
  }
}
function removeEventListener(event, func) {
  if (ENAFORE_IS_BROWSER && !ENAFORE_IS_SERVICE_WORKER) {
    importPageLifecycle().then((lifecycle2) => {
      lifecycle2.removeEventListener(event, func);
    });
  }
}
export const lifecycle = { addEventListener, removeEventListener };
